export default __webpack_public_path__ + "static/media/icn_drag.1a8564a9.svg";